import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import MainContent, { TableContent } from 'components-shared'
import EmptyScreen from 'packages/ui/EmptyScreen'

import Filters from './Filters'
import SelectionBanner, { CounterBanner } from './SelectionBanner'
import Table from './Table'
import { useResetSelectionOnFiltersChange, useSelection } from './store'
import useSitesUnscope from './use-sites-unscope'

const AdminSites = () => {
  const { t } = useTranslation()
  const { hasSelection } = useSelection()
  const apiSites = useSitesUnscope()
  useResetSelectionOnFiltersChange()

  return (
    <Stack flex={1}>
      <Filters />
      {
        hasSelection
          ? <SelectionBanner sites={apiSites.sites} />
          : <CounterBanner />
      }
      <MainContent>
        <TableContent>
          {apiSites.error ? (
            <EmptyScreen icon="triangle-exclamation" iconSize="80px">
              {t('admin_sites.error')}
            </EmptyScreen>
          ) : (
            <Table apiSites={apiSites} />
          )}
        </TableContent>
        <Outlet />
      </MainContent>
    </Stack>
  )
}

export default AdminSites
